var map = {
	"./10-mln-ai.png": 6065,
	"./101-midjourney-ekspert.png": 844,
	"./101-polecen-ai.png": 288,
	"./101-polecen-grafika-ai.png": 5165,
	"./101-polecen-portretow.png": 1244,
	"./101-strategii-bogactwa-ai.png": 9672,
	"./101-styli-mj.png": 6296,
	"./10mln-shorts.png": 2233,
	"./10mln-tt-2024.png": 9319,
	"./1mln-insta-przewodnik.png": 6554,
	"./1mln-zasiegu.png": 4976,
	"./30insta-tat.png": 7710,
	"./30tat-tt.png": 2663,
	"./360-video-genius.png": 8922,
	"./57-tools-sm.png": 3903,
	"./5days-webinars.png": 7240,
	"./5dni-webi.png": 4465,
	"./7dni-coaching.png": 5381,
	"./ai-graphic-30tt.png": 553,
	"./canva-30tt.png": 1192,
	"./capcut-master-vip.png": 8200,
	"./ebook-mindset-milionera.png": 8082,
	"./instagram-100k.png": 4820,
	"./iphone-34pozy.png": 7599,
	"./iphone-checklista-zdjecia.png": 4763,
	"./iphone-lista-akcesoriow.png": 757,
	"./iphone-master-video.png": 6271,
	"./iphone-photo-masterclass.png": 4196,
	"./iphone-photo-video-warsztaty.png": 1715,
	"./iphone-photo-video-zoom.png": 2328,
	"./iphone-produktywnosc.png": 291,
	"./iphone-video-masterclass.png": 5884,
	"./prompt-ekspert-ai.png": 7656,
	"./reels-project-genius.png": 3602,
	"./sekret-algo-insta.png": 3795,
	"./sekret-napisow.png": 3660,
	"./szkola-algo-tt.png": 9214,
	"./szkola-video-tele.png": 8008,
	"./video-30tt.png": 3892,
	"./video-ai-masterclass.png": 9785,
	"./video-ai-milion-coaching.png": 7855,
	"./video-coaching-zoom.png": 3803,
	"./virtual-influencer-ai.png": 3566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706;